module.exports = __webpack_public_path__ + "static/pierpass-b0e6a244c29ca5c3e20ce61d092eca12.jpg";